import { useMemo } from 'react';
import { AttributeColumnRenderer, Attributes, Formatters } from '@leverege/ui-attributes';
import { System } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
export default class EnumColumnRenderer extends AttributeColumnRenderer {
  formatAndI18nResolveValue = value => {
    if (value == null) {
      return this.column?.cell?.emptyValue;
    }
    const {
      objectType,
      attrName
    } = this.column;
    const attribute = Attributes.getAttribute(attrName, objectType);
    const resourceEnumType = attribute?.blueprint?.attribute?.model?.enumType;
    const enumValues = System(window.Molten.getConfig('api/systemId')).resourceEnum(resourceEnumType).getResourceEnum(GlobalState.get());
    const valueData = useMemo(() => enumValues?.values?.find(v => v?.value === value), [enumValues, value]);
    const formattedValue = Formatters.format(valueData?.name || value, this.column.formatter);
    return formattedValue;
  };
}